import * as Yup from "yup";

const validationSchema = (categories:any) => {
  return Yup.object().shape({
    displayName: Yup.string()
      .required("US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD")
      .test("is-in-category-list", "US.COLLECTION.VALIDATIONS:REQUIRED.DISPLAY_NAME_ALREADY_EXISTS", function (value) {
        return !categories.includes(value?.toLowerCase());
      }),
  });
};

export default validationSchema;